import React from 'react'
import styles from './MicrositePublishButton.module.css'
import { Rocket, RefreshCw } from 'lucide-react'

/**
 * MicrositePublishButton
 * Big CTA button for triggering micrositePublishSite, with a
 * loading spinner during the BUILDING state and disabled state
 * while a build is already in progress.
 *
 * Usage:
 *   <MicrositePublishButton
 *     buildStatus={buildStatus}
 *     onClick={handlePublish}
 *   />
 */
const MicrositePublishButton = ({ buildStatus, onClick }) => {
    const isBuilding = buildStatus === 'BUILDING'

    return (
        <button type="button" className={styles.btn} onClick={onClick} disabled={isBuilding}>
            {isBuilding ? (
                <>
                    <RefreshCw size={16} className={styles.spinner} />
                    Publishing…
                </>
            ) : (
                <>
                    <Rocket size={16} />
                    Publish site
                </>
            )}
        </button>
    )
}

export default MicrositePublishButton